var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid__container"},[_c('div',{staticClass:"grid__row",style:(`grid-template-columns: repeat(${_vm.numbersColumns}, 1fr)`)},_vm._l((_vm.numbersColumns),function(col){return _c('div',{key:`col-${col}`,staticClass:"grid__col"},[_vm._t(`col${col}`)],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }